import {
  ACT_USERS_FETCH_INIT,
  ACT_USERS_FETCH_200, ACT_UPDATE_SELECTED_USER,
} from '../constants/actions';

const defaultState = {
  usersList: [],
  isLoadingUsers: false,
  didLoadUsers: false,
  selectedUser: undefined,
};

const usersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_USERS_FETCH_INIT:
      return {
        ...state,
        usersList: [],
        isLoadingUsers: true,
        didLoadUsers: false,
      };
    case ACT_USERS_FETCH_200:
      return {
        ...state,
        usersList: action.payload,
        isLoadingUsers: false,
        didLoadUsers: true,
      };
    case ACT_UPDATE_SELECTED_USER:
      return {
        ...state,
        selectedUser: action.payload,
      };
    default:
      return state;
  }
};

export default usersReducer;
